import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Modal } from "react-bootstrap";

export default function ImportItemsPage() {
  const [jobs, setJobs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [jobName, setJobName] = useState("");
  const [importType, setImportType] = useState("batch-create");
  const [expandedJobId, setExpandedJobId] = useState(null); // ID открытой карточки

  useEffect(() => {
    fetchJobs();
    const interval = setInterval(fetchJobs, 3000);
    return () => clearInterval(interval);
  }, []);

  const fetchJobs = async () => {
    const response = await api.get("/ImportItems/jobs");
    setJobs(response.data);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleImport = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    await api.post(`/ImportItems/${importType}?name=${encodeURIComponent(jobName)}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    setIsModalOpen(false);
    setFile(null);
    setJobName("");
    fetchJobs();
  };

  const downloadFile = async (type, jobId) => {
    const response = await api.get(`/ImportItems/download/${jobId}/${type}`, {
      responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${type}_${jobId}.xlsx`);
    document.body.appendChild(link);
    link.click();
  };

  const abortJob = async (jobId) => {
    await api.post(`/ImportItems/abort/${jobId}`);
    fetchJobs();
  };

  const toggleExpand = (jobId) => {
    setExpandedJobId(expandedJobId === jobId ? null : jobId);
  };

  const statusLabels = {
    [-1]: "Ошибка",
    [0]: "Отменено",
    [1]: "Ожидание",
    [2]: "В процессе",
    [3]: "Завершено"
  };

  const getProgress = (job) => {
    if (job.totalCount === 0) return 0;
    return Math.round(((job.successCount + job.errorCount) / job.totalCount) * 100);
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between mb-4">
        <h1 className="h3">Импорт товаров</h1>
        <button
          className="btn btn-primary"
          onClick={() => setIsModalOpen(true)}
        >
          Новый импорт
        </button>
      </div>

      <div className="row g-4">
        {jobs.map((job) => (
          <div key={job.id} className="col-12">
            <div className="card">
              <div
                className="card-body"
                style={{ cursor: "pointer" }}
                onClick={() => toggleExpand(job.id)}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="card-title mb-1">{job.name}</h5>
                    <small className="text-muted">Создано: {new Date(job.creationTime).toLocaleString()}</small>
                  </div>
                  <div className="text-end">
                    <p className="mb-0"><strong>Статус:</strong> {statusLabels[job.status]}</p>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-3 col-6">
                    <small className="text-muted d-block">Создатель:</small>
                    <div>{job.createdByName}</div>
                  </div>
                  <div className="col-md-3 col-6">
                    <small className="text-muted d-block">Успешно:</small>
                    <div>{job.successCount}</div>
                  </div>
                  <div className="col-md-3 col-6 mt-2 mt-md-0">
                    <small className="text-muted d-block">Ошибки:</small>
                    <div>{job.errorCount}</div>
                  </div>
                  <div className="col-md-3 col-6 mt-2 mt-md-0">
                    <small className="text-muted d-block">Всего:</small>
                    <div>{job.totalCount}</div>
                  </div>
                </div>
              </div>

              {expandedJobId === job.id && (
                <>
                  <div className="card-body border-top">
                    <div className="progress my-2" style={{ height: "6px" }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${getProgress(job)}%` }}
                        aria-valuenow={getProgress(job)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <small className="text-muted">{getProgress(job)}% выполнено</small>
                  </div>
                  <div className="card-footer d-flex flex-wrap gap-2">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => downloadFile("incoming", job.id)}
                    >
                      Скачать исходный файл
                    </button>
                    <button
                      className="btn btn-outline-success"
                      onClick={() => downloadFile("success", job.id)}
                    >
                      Скачать успешные
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      onClick={() => downloadFile("error", job.id)}
                    >
                      Скачать ошибки
                    </button>
                    {(job.status === 1 || job.status === 2) && (
                      <button
                        className="btn btn-warning"
                        onClick={() => abortJob(job.id)}
                      >
                        Отменить импорт
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Новый импорт</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Название импорта</label>
            <input
              type="text"
              className="form-control"
              value={jobName}
              onChange={(e) => setJobName(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Тип импорта</label>
            <div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="importType"
                  value="batch-create"
                  checked={importType === "batch-create"}
                  onChange={(e) => setImportType(e.target.value)}
                />
                <label className="form-check-label">Создание</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="importType"
                  value="batch-update"
                  checked={importType === "batch-update"}
                  onChange={(e) => setImportType(e.target.value)}
                />
                <label className="form-check-label">Обновление</label>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Файл Excel</label>
            <input
              type="file"
              accept=".xlsx"
              onChange={handleFileChange}
              className="form-control"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>
            Отмена
          </button>
          <button className="btn btn-primary" onClick={handleImport}>
            Импортировать
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
